import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = isArabic ? 'rtl' : 'ltr';
    document.documentElement.style.fontFamily = isArabic
      ? "'Noto Sans Arabic', 'IBM Plex Sans Arabic', system-ui, sans-serif"
      : '';
  }, [i18n.language, isArabic]);

  const toggle = () => {
    i18n.changeLanguage(isArabic ? 'en' : 'ar');
  };

  return (
    <button
      onClick={toggle}
      title={isArabic ? 'Switch to English' : 'التبديل إلى العربية'}
      className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 border border-slate-300 dark:border-slate-700 hover:border-slate-400 dark:hover:border-slate-600 text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white transition-all text-xs font-medium"
    >
      <Languages className="w-3.5 h-3.5 flex-shrink-0" />
      <span>{isArabic ? 'EN' : 'ع'}</span>
    </button>
  );
}
